import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppEmbedModule } from './app/app-embed.module';
import { AppSiteModule } from './app/app-site.module';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

(async (): Promise<void> => {
    try {
        const configPath = environment.configurationPath ?? 'assets/configuration/env-configuration.json';
        const timeStamp = Date.now();
        const response: Response = await fetch(`${configPath}?ts=${timeStamp}`);
        const config = await response.json();

        environment.configuration = config;
        if (environment.production) {
            enableProdMode();
        }

        const isSite = config.isSite;

        const isEmbed = window.location.pathname.includes('/embed.html');
        let module = AppModule;
        if (isSite) {
            module = AppSiteModule;
        } else if (isEmbed) {
            module = AppEmbedModule;
        }

        platformBrowserDynamic()
            .bootstrapModule(module)
            .catch((err) => console.error(err));
    } catch (e: any) {
        throw new Error('Error loading environment configuration\n' + e.message);
    }
})();
